<template>
    <div class="ScenariosUnlockedPopup">
        <div class="header">
            <div class="image" :style="{ backgroundImage: `url(${backgroundImage})` }" />
            <div class="icon">
                <svgicon class="svg-icon" icon="dumbbells" />
            </div>
        </div>
        <div class="body">
            <div class="title">
                {{ $t('title') }}
            </div>
            <div class="subtitle">
                {{ $t('subtitle', { title: $t(`dashboard.general.lifeskillLabels.${lifeskillId}`) }) }}
            </div>
        </div>
        <div class="footer">
            <StandardButton :label="$t('button')" icon="arrow-right" :theme="theme" @click="goNext()" />
        </div>
    </div>
</template>

<translations>
  title: 'You unlocked Practice'
  title_no: 'Du åpnet opp Praksis'
  subtitle: 'Start your journey for good {title} habits with daily scenario training.'
  subtitle_no: 'Start ferden til nye vaner i {title} med daglig scenariotrening.'
  button: 'Do your daily scenario'
  button_no: 'Gjør ditt daglige scenario'
</translations>

<script>
import categoryThemes from '@/category-themes';
import { getCategoryIdFromLifeskillId } from '@/utils';
import StandardButton from '@/components/StandardButton';

const images = require.context('@/assets/images/', true, /\.(png|jpg)$/);

export default {
    components: { StandardButton },
    props: {
        lifeskillId: {
            type: String,
            required: true
        }
    },
    provide() {
        return {
            theme: this.theme
        };
    },
    data() {
        return {
            theme: categoryThemes[getCategoryIdFromLifeskillId(this.lifeskillId)]
        };
    },
    computed: {
        lifeskill() {
            return this.$store.state.moduleApp.lifeskills[this.lifeskillId];
        },
        backgroundImage() {
            try {
                return images(`./lifeskill-backgrounds-large/${this.lifeskillId}.jpg`);
            } catch (err) {
                return null;
            }
        }
    },
    created() {},
    methods: {
        goNext() {
            this.$emit('signal');

            this.$router.push({
                name: 'DashboardLifeskillViewWithTab',
                params: { lifeskillId: this.lifeskillId, tabName: 'practice' }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.ScenariosUnlockedPopup {
    background-color: white;

    position: relative;
    width: 26em;
}
.header {
    position: relative;
    background-color: black;
    padding: 4em 2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.7;

    background-position: center;
    background-size: cover;
}
.icon {
    $size: 5em;
    width: $size;
    height: $size;
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;

    background-color: rgba(black, 0.8);

    .svg-icon {
        $size: 50%;
        width: $size;
        height: $size;
        fill: white;
    }
}
.name {
    color: white;
    font-size: 120%;
}
.body {
    padding: 2em;
    color: rgba(black, 0.7);
    text-align: center;
}
.title {
    font-size: 140%;
    color: rgba(black, 0.9);
}
.subtitle {
    line-height: 1.5em;
    margin-top: 1em;
}
.footer {
    text-align: center;
    padding: 2em;
    padding-top: 0;
}
</style>
